module.exports = {}


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/base/components/utils/img-url/icon.json
// module id = 579
// module chunks = 438